import React, { Component } from "react";

class Home extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="home-container">
          <div className="overlay"></div>
          <div className="home-content">
            {/* Left Panel - Welcome Text */}
            <div className="home-left-panel show-text-on-desktop">
              <div className="home-text-wrapper">
                <h1 className="home-title">Welcome to <span className="home-title-accent">FilmFuse</span></h1>
                <p className="home-subtitle">The Creative Platform for Modern Filmmakers</p>
                <p className="home-description">
                  Connect with filmmakers, producers, screenwriters, and composers worldwide. 
                </p>
                <div className="home-features">
                  <div className="home-feature-item">
                    <div className="home-feature-icon">🎬</div>
                    <div className="home-feature-text">Film Market & Networking</div>
                  </div>
                  <div className="home-feature-item">
                    <div className="home-feature-icon">💰</div>
                    <div className="home-feature-text">Monetized Streaming Service</div>
                  </div>
                  <div className="home-feature-item">
                    <div className="home-feature-icon">📋</div>
                    <div className="home-feature-text">Production Management Tools</div>
                  </div>
                  <div className="home-feature-item">
                    <div className="home-feature-icon">💼</div>
                    <div className="home-feature-text">Job Board & Opportunities</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Panel - Logo and CTA Buttons */}
            <div className="home-right-panel">
              <div className="home-card">
                <div className="home-logo-wrapper">
                  <img
                    src="/images/filmfuse-logo.png"
                    className="home-logo show-desktop-logo"
                    alt="FilmFuse Logo"
                  />
                  <img
                    src="/images/filmfuselogo.png"
                    className="home-logo show-mobile-logo"
                    alt="FilmFuse Logo"
                  />
                </div>
                
                <div className="home-cta-section">
                  <h2 className="home-cta-title">Ready to Create?</h2>
                  <p className="home-cta-subtitle">Join thousands of filmmakers on FilmFuse</p>
                  
                  <div className="home-buttons">
                    <a href="/login" className="home-btn home-btn-secondary">
                      Login
                    </a>
                    <a href="/signup" className="home-btn home-btn-primary">
                      Sign Up
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Text Panel */}
            <div className="home-mobile-text-panel show-text-on-mobile">
              <div className="home-text-wrapper">
                <h1 className="home-title-mobile">Welcome to <span className="home-title-accent">FilmFuse</span></h1>
                <p className="home-description-mobile">
                  Connect with filmmakers, producers, screenwriters, and composers worldwide. Access a film market, monetized streaming service, production office with call sheets, and a job board for finding and posting opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Home;
